module.exports = __webpack_public_path__ + "static/media/FORMATO CERTIFICADO DE ACTIVIDADES DE PERSONAL ADMINISTRATIVO.a86f756f.pdf";